import type { NightAiIconId } from "../../config/nightAiCardContent";

interface NightAiScenarioIconProps {
  icon: NightAiIconId;
}

export function NightAiScenarioIcon({ icon }: NightAiScenarioIconProps) {
  return (
    <svg className="night-ai-scenario-icon__glyph" viewBox="0 0 72 72" fill="none" aria-hidden="true">
      {icon === "wash" ? <WashIcon /> : null}
      {icon === "charge" ? <ChargeIcon /> : null}
      {icon === "park" ? <ParkIcon /> : null}
      {icon === "package" ? <PackageIcon /> : null}
      {icon === "fuel" ? <FuelIcon /> : null}
      {icon === "history" ? <HistoryIcon /> : null}
      {icon === "accident" ? <HistoryIcon /> : null}
      {icon === "standby" ? <StandbyIcon /> : null}
    </svg>
  );
}

function WashIcon() {
  return (
    <>
      <path d="M17.5 39.7C19.6 30.7 23.2 24.8 28.3 24.8H43.7C48.8 24.8 52.4 30.7 54.5 39.7" stroke="currentColor" strokeWidth="6.2" strokeLinecap="round" />
      <path d="M23.6 38.8H48.4C52.9 38.8 56.4 42.3 56.4 46.8V51.1C56.4 53.5 54.5 55.4 52.1 55.4H50.2C48.6 55.4 47.1 54.4 46.5 52.9H25.5C24.9 54.4 23.4 55.4 21.8 55.4H19.9C17.5 55.4 15.6 53.5 15.6 51.1V46.8C15.6 42.3 19.1 38.8 23.6 38.8Z" fill="currentColor" opacity="0.84" />
      <circle cx="25.1" cy="47.1" r="3.3" fill="var(--icon-detail)" />
      <circle cx="46.9" cy="47.1" r="3.3" fill="var(--icon-detail)" />
      <path d="M55 18.5L57.6 24.4L63.5 27L57.6 29.6L55 35.5L52.4 29.6L46.5 27L52.4 24.4L55 18.5Z" fill="currentColor" opacity="0.66" />
      <path d="M26 15.8L27.8 19.8L31.8 21.6L27.8 23.4L26 27.4L24.2 23.4L20.2 21.6L24.2 19.8L26 15.8Z" fill="currentColor" opacity="0.46" />
    </>
  );
}

function ChargeIcon() {
  return (
    <>
      <path d="M17.8 25C17.8 21.4 20.6 18.8 24.2 18.8H46.8C50.4 18.8 53.2 21.4 53.2 25V50C53.2 53.6 50.4 56.2 46.8 56.2H24.2C20.6 56.2 17.8 53.6 17.8 50V25Z" stroke="currentColor" strokeWidth="6" />
      <path d="M28.8 14H42.2" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
      <path d="M39.7 26.5L27.8 40.2H36.3L32.3 52.8L44.2 38.7H35.7L39.7 26.5Z" fill="currentColor" opacity="0.84" />
    </>
  );
}

function ParkIcon() {
  return (
    <>
      <path d="M19.5 56.5V17.5H38.8C46.8 17.5 52.5 23.1 52.5 30.6C52.5 38.1 46.8 43.6 38.8 43.6H31.2V56.5H19.5Z" fill="currentColor" opacity="0.84" />
      <path d="M31.2 27.1V34.5H37.8C40.6 34.5 42.5 33 42.5 30.8C42.5 28.6 40.6 27.1 37.8 27.1H31.2Z" fill="var(--icon-detail)" />
      <path d="M53.5 17L55.6 21.8L60.5 24L55.6 26.2L53.5 31L51.4 26.2L46.5 24L51.4 21.8L53.5 17Z" fill="currentColor" opacity="0.38" />
    </>
  );
}

function PackageIcon() {
  return (
    <>
      <path d="M16.5 26.3L36 15.8L55.5 26.3V51L36 61.2L16.5 51V26.3Z" fill="currentColor" opacity="0.84" />
      <path d="M17.4 26.9L36 37.4L54.6 26.9" stroke="var(--icon-detail)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36 37V60.2" stroke="var(--icon-detail)" strokeWidth="5" strokeLinecap="round" />
    </>
  );
}

function FuelIcon() {
  return (
    <>
      <path d="M24.5 16.5H44.5C48.5 16.5 51.5 19.5 51.5 23.5V56.5H17.5V23.5C17.5 19.5 20.5 16.5 24.5 16.5Z" fill="currentColor" opacity="0.78" />
      <path d="M26.5 25.5H42.5V34.5H26.5V25.5Z" fill="var(--icon-detail)" />
      <path d="M51.5 28.5H56.5C58.4 28.5 60 30.1 60 32V47C60 49.2 58.2 51 56 51C53.8 51 52 49.2 52 47V42.5" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
      <path d="M48 16.5L56.5 25" stroke="currentColor" strokeWidth="5" strokeLinecap="round" opacity="0.7" />
      <path d="M33.5 43L29.5 50H39.5L35.5 58" stroke="var(--icon-detail)" strokeWidth="4.6" strokeLinecap="round" strokeLinejoin="round" />
    </>
  );
}

function HistoryIcon() {
  return (
    <>
      <path d="M36 16.5C25.2 16.5 16.5 25.2 16.5 36S25.2 55.5 36 55.5 55.5 46.8 55.5 36" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
      <path d="M17 22.5V34H28.5" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M36 26.5V37L44 42.5" stroke="currentColor" strokeWidth="5.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M52.5 18.5L54.7 23.4L59.5 25.5L54.7 27.6L52.5 32.5L50.3 27.6L45.5 25.5L50.3 23.4L52.5 18.5Z" fill="currentColor" opacity="0.48" />
    </>
  );
}

function StandbyIcon() {
  return (
    <>
      <path d="M17.5 39.7C19.6 30.7 23.2 24.8 28.3 24.8H43.7C48.8 24.8 52.4 30.7 54.5 39.7" stroke="currentColor" strokeWidth="6.2" strokeLinecap="round" />
      <path d="M23.6 38.8H48.4C52.9 38.8 56.4 42.3 56.4 46.8V51.1C56.4 53.5 54.5 55.4 52.1 55.4H50.2C48.6 55.4 47.1 54.4 46.5 52.9H25.5C24.9 54.4 23.4 55.4 21.8 55.4H19.9C17.5 55.4 15.6 53.5 15.6 51.1V46.8C15.6 42.3 19.1 38.8 23.6 38.8Z" fill="currentColor" opacity="0.74" />
      <circle cx="25.1" cy="47.1" r="3.3" fill="var(--icon-detail)" />
      <circle cx="46.9" cy="47.1" r="3.3" fill="var(--icon-detail)" />
      <path d="M55 18.5L57.1 23.4L62 25.5L57.1 27.6L55 32.5L52.9 27.6L48 25.5L52.9 23.4L55 18.5Z" fill="currentColor" opacity="0.58" />
    </>
  );
}
